import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import { AppService } from '../../../../app.service';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service';
import { ModalService } from 'src/app/common/modal/modal.service';

@Component({
    selector: 'app-form-field-number-v2',
    templateUrl: './form-field-number-v2.component.html',
    styleUrls: ['./form-field-number-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldNumberV2Component implements OnInit {
  @Input() configData: any;
  @Input() frmGroup: UntypedFormGroup;

  constructor(private appService: AppService, private alphaService: AlphaService, private modalService:ModalService,private apiService: AppService,) { }

  placeHolder = "";
  validationType: string = "";
  disabled: boolean = false;
  templateData: any;
  selfServiceConfig: boolean = false;
  orderFormSubmitted;
  orderForm: any;
  isLoading: boolean;
  

  @ViewChild('formFieldWrapper', {static: true, read: ElementRef}) formFieldWrapper;
  @ViewChild('numberInput', {static: true}) numberInput: ElementRef;

  toggleEnable(bool){
    if(bool)
      this.frmGroup.get(this.configData.name).disable();
    else
      this.frmGroup.get(this.configData.name).enable();    
  }

  ngOnInit() {  
    //Check Self service status 
    if (this.configData.customFormFlag) {
      this.selfServiceConfig = false;
    } else if (sessionStorage.getItem("isSelfServiceConfig")) {
      this.selfServiceConfig = true;
    } //END

    if (this.configData["disabled"]) {
      this.toggleEnable(true);
    } else {
      this.toggleEnable(false);      
    }

    this.configData.validation.forEach((element) => {
      if (element === "Numeric") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.min(1));
        this.frmGroup
          .get(this.configData.name)
          .setValidators(Validators.pattern(new RegExp("^0*[1-9]\\d*$")));
      } else if (element === "Decimal") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.min(1));
        this.frmGroup
          .get(this.configData.name)
          .setValidators(
            Validators.pattern(
              new RegExp("^\\s*(?=.*[1-9])\\d*(?:\\.\\d{1,99})?\\s*$")
            )
          );
      } else if (element === "DecimalWithMaxlength") {
        this.validationType = element;
        this.frmGroup
          .get(this.configData.name)
          .setValidators(
            Validators.pattern(
              new RegExp(/^\s*(?=.*[1-9])\d{1,3}(?:\.\d{1,2})?\s*$/)
            )
          );
      }
      if (element === "hidden") {
        if (!(this.frmGroup.get(this.configData.name)["hidden"] === false)) {
          this.frmGroup.get(this.configData.name)["hidden"] = true;
        }
      }
    }, this);
  }

  sendToSource(event: DhlFormControlEvent, row = {} ) {
    let eventData: DhlFormControlEventData = {
      action: 'VOLUME_CALCULATION',
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: row,
      event: 'RATE_LOOKUP',
      eventData: undefined
    }
    this.appService._commonComponentSubject.next(eventData);
  }
  ngAfterViewInit() {
    this.frmGroup.get(this.configData.name).statusChanges.subscribe(x => {
      if (this.configData.volCalculation) {
        let event: DhlFormControlEvent
        setTimeout(() => {
          this.sendToSource(event, this.frmGroup.value);
        })
      }


      if(this.frmGroup.get(this.configData.name).value == undefined || this.frmGroup.get(this.configData.name).value == null) {
        this.formFieldWrapper.nativeElement.classList.remove("dhl-form-field--is-active",
          "dhl-form-field--set-borderRed", "dhl-form-field--set-border-success", "dhl-form-field--is-filled");
      }
    });

    if(this.frmGroup.get(this.configData.name).value) {
      this.formFieldWrapper.nativeElement.classList.add("dhl-form-field--is-filled");
    }
  }

    //Set the number after click this function
    quantityUpDownFn = (type, keepAffectedColumnValues = false) => {
      let currentInputFieldData = +this.frmGroup.get(this.configData.name).value || 0;
      currentInputFieldData = type == 'minus' ? currentInputFieldData - 1 : currentInputFieldData + 1; //Subtract/add one more Number
      if (currentInputFieldData > 0) {
        this.frmGroup.get(this.configData.name).setValue(currentInputFieldData.toString()); //Set Values
        this.frmGroup.get(this.configData.name).updateValueAndValidity();//Update Valus and validation
        this.numberInput.nativeElement.querySelector('input').focus(); //Auto Select input fields
        this.validateInput(this.configData.name, this.frmGroup.get(this.configData.name).value) //Validate the input data
        this.alphaService.manageAffectedColumn(this.configData, this.frmGroup, currentInputFieldData.toString(), keepAffectedColumnValues);
      }
    }

  public onBlurSetActive(el, active) {
    el = document.getElementById(el);
    const formField = el.parentNode.parentNode;
    if (active) {
      this.placeHolder = (this.configData && this.configData.placeHolder) ? this.configData.placeHolder: "";
      formField.classList.add("dhl-form-field--is-active");
    } else {
      this.placeHolder = "";
      formField.classList.remove("dhl-form-field--is-active");
      el.value === ""
        ? formField.classList.remove(
            "dhl-form-field--is-filled",
            "dhl-form-field--set-borderRed"
          )
        : formField.classList.add("dhl-form-field--is-filled");
    }
  }

  public validateInput(el, value) {
    
    value = value.trim();
    if (this.configData.type !== "number") {
      this.frmGroup.get(this.configData.name).setValue(value.trim());
    }

    el = document.getElementById(el);
    const formField = el.parentNode.parentNode;
    if (this.frmGroup.get(this.configData.name).invalid || this.frmGroup.get(this.configData.name).errors) {
      formField.classList.remove("dhl-form-field--set-border-success");
      formField.classList.add("dhl-form-field--set-border-error");
    } else {
      formField.classList.remove("dhl-form-field--set-border-error");
      formField.classList.remove("dhl-form-field--set-border-success");
      if (this.frmGroup.get(this.configData.name).value && this.frmGroup.get(this.configData.name).value !== "") {
        formField.classList.add("dhl-form-field--set-border-success");
      }
    }
  }

  public clearInput() {
    this.frmGroup.get(this.configData.name).setValue("") ;
  }

  setValueToControl(value){
    if (value != undefined) {
      this.frmGroup.get(this.configData.name).setValue(value);
    }
  }

  controlValueChange(e, keepAffectedColumnValues = false) {
    this.alphaService.manageAffectedColumn(this.configData, this.frmGroup, e.target.value.trim(), keepAffectedColumnValues);
  }
}
